import ReactMarkdown from "react-markdown";

export function Markdown({ children, className = "" }) {
  return (
    <div className={`text-sm leading-relaxed space-y-2 ${className}`} data-testid="markdown-content">
      <ReactMarkdown
        components={{
          p: ({ node, ...props }) => <p className="text-foreground/90" {...props} />,
          strong: ({ node, ...props }) => <strong className="font-semibold text-foreground" {...props} />,
          ul: ({ node, ...props }) => <ul className="list-disc pl-5 space-y-1 marker:text-primary" {...props} />,
          ol: ({ node, ...props }) => <ol className="list-decimal pl-5 space-y-1 marker:text-primary" {...props} />,
          li: ({ node, ...props }) => <li className="text-foreground/90" {...props} />,
          h1: ({ node, ...props }) => <h3 className="font-heading font-bold text-base" {...props} />,
          h2: ({ node, ...props }) => <h3 className="font-heading font-bold text-base" {...props} />,
          h3: ({ node, ...props }) => <h3 className="font-heading font-semibold text-sm" {...props} />,
          a: ({ node, ...props }) => <a className="text-primary underline" {...props} />,
          code: ({ node, ...props }) => <code className="rounded bg-muted px-1 py-0.5 text-xs" {...props} />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
